import ministryService from "../../services";
export default {
  namespaced: true,
  state: {
    loading: false,
    working: false,
    notifications: [],
    pagination : {} ,
    filterKey: "",
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
    pagination(state) {
      return state.pagination;
    },
    notifications(state) {
      return state.filterKey.length > 0
        ? state.notifications.filter((el) => el.title.includes(state.filterKey))
        : state.notifications;
    },
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
    setNotifications(state, payload) {
      state.notifications = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setFilterKey(state, payload) {
      state.filterKey = payload;
    },
  },

  actions: {
    filterNotifications({ commit }, searchKey) {
      commit("setFilterKey", searchKey);
    },
    async fetchNotifications({ commit } , page=1 ) {
      commit("setLoading", true);
      try {
        const data = await ministryService.fetchNotifications(page);
        commit("setNotifications", data.data);
        commit('setPagination' , data.pagination)
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async addNotification({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        const res = await ministryService.addNotification(payload);
        if (res.status <= 500 && res.status >= 400) throw res.status;
        dispatch("fetchNotifications");
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      } finally {
        commit("setWorking", false);
      }
    },
    async updateNotification({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        const res = await ministryService.updateNotification(payload);
        if (res.status <= 500 && res.status >= 400) throw res.status;
        dispatch("fetchNotifications");
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      } finally {
        commit("setWorking", false);
      }
    },
    async deleteNotification({ commit, dispatch }, id) {
      commit("setLoading", true);
      try {
        const res = await ministryService.deleteNotification(id);
        if (res.status <= 500 && res.status >= 400) throw res.status;
        dispatch("fetchNotifications");
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      } finally {
        commit("setLoading", false);
      }
    },
    async sendNotification({ commit }, payload) {
      commit("setWorking", true);
      try {
        const res = await ministryService.sendNotification(payload);
        commit("setWorking", false);
        if (res.status <= 500 && res.status >= 400) throw res.status;
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      } finally {
        commit("setWorking", false);
      }
    },
  },
};
